<div class="h-full w-full flex flex-col overflow-hidden">
    <div class="h-full w-full flex flex-col items-center justify-center">
        <h2
            class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left">
            How do you want to
            <span class="bg-linear-to-r from-primary to-brand-studio bg-clip-text text-transparent">build</span>?
        </h2>
        <p class="mx-auto mt-2 max-w-2xl text-base sm:text-lg/8 text-pretty text-secondary text-center">
            The same brief, two flows — pick how you want to work. Let our AI draft the whole thing or follow a guided
            wizard step by step.</p>

        <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">
            <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-6">

                <!-- AI First Brief -->
                <article (click)="choose.emit('ai')" data-guide-id="createBrief.chooseAi"
                    class="flex flex-col group overflow-hidden rounded-xl border border-gray-200 dark:border-white/10 flex flex-col gap-y-2 hover:border-fuchsia-500 dark:hover:border-fuchsia-400 cursor-pointer shadow-md group-hover:shadow-lg transition-all duration-300">
                    <div class="w-full p-4 group-hover:p-2 transition-all duration-300">
                        <img src="../../../../../assets/images/01-ai-first-brief.png"
                            class="block w-full h-auto object-contain" alt="">
                    </div>
                    <div class="p-4 flex flex-col h-full justify-between">
                        <div class="flex-1 flex flex-col">
                            <span
                                class="inline-flex w-fit self-start items-center gap-x-1.5 rounded-full bg-fuchsia-100 px-2 py-1 text-xs font-medium text-fuchsia-500 dark:bg-fuchsia-400/10 dark:text-fuchsia-400">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-4 text-fuchsia-500 dark:text-fuchsia-400">
                                    <path
                                        d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                                </svg>
                                SHOUT AI
                            </span>
                            <h1
                                class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl dark:text-white group-hover:text-5xl group-hover:text-fuchsia-500 transition-all duration-300">
                                AI-First Brief</h1>
                            <p class="mt-6 text-sm text-primary">Describe the brief in a sentence.
                                SHOUT
                                AI drafts concepts, creative steps, do's & don'ts, creator persona and screening
                                questions -
                                you review and refine.</p>
                        </div>
                        <div class="shrink-0 flex flex-row items-center justify-between pt-4">
                            <a
                                class="font-medium whitespace-nowrap text-fuchsia-500 hover:text-fuchsia-600 dark:text-fuchsia-300 dark:hover:text-fuchsia-200">
                                Start with AI
                                <span aria-hidden="true"> &rarr;</span>
                            </a>
                            <p class="text-xs text-secondary">~2 min</p>
                        </div>
                    </div>
                </article>
                <!-- AI First Brief - END -->

                <!-- Guided Wizard Brief -->
                <article (click)="choose.emit('wizard')" data-guide-id="createBrief.chooseWizard"
                    class="flex flex-col group overflow-hidden rounded-xl border border-gray-200 dark:border-white/10 flex flex-col gap-y-2 hover:border-fuchsia-500 dark:hover:border-fuchsia-400 cursor-pointer shadow-md group-hover:shadow-lg transition-all duration-300">
                    <div class="w-full p-4 group-hover:p-2 transition-all duration-300">
                        <img src="../../../../../assets/images/02-guided-wizard.png"
                            class="block w-full h-auto object-contain" alt="">
                    </div>
                    <div class="p-4 flex flex-col h-full justify-between">
                        <div class="flex-1 flex flex-col">
                            <span
                                class="inline-flex w-fit self-start items-center gap-x-1.5 rounded-full bg-fuchsia-100 px-2 py-1 text-xs font-medium text-fuchsia-500 dark:bg-fuchsia-400/10 dark:text-fuchsia-400">
                                Guided
                            </span>
                            <h1
                                class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl dark:text-white group-hover:text-5xl group-hover:text-fuchsia-500 transition-all duration-300">
                                Guided Wizard</h1>
                            <p class="mt-6 text-sm text-primary">One decision at a time. A seven-step
                                path walks you through product, brief, content type, creative direction, audience and
                                screening before launch.</p>

                        </div>
                        <div class="shrink-0 flex flex-row items-center justify-between pt-4">
                            <a
                                class="font-medium whitespace-nowrap text-fuchsia-500 hover:text-fuchsia-600 dark:text-fuchsia-300 dark:hover:text-fuchsia-200">
                                Open Wizard
                                <span aria-hidden="true"> &rarr;</span>
                            </a>
                            <p class="text-xs text-secondary">7 steps</p>
                        </div>
                    </div>
                </article>
                <!-- Guided Wizard Brief - END -->
            </div>
        </div>
    </div>
</div>